export default __webpack_public_path__ + "static/kalgen-logo-35bdbedb687a3c59b82783a2264fd3b5.jpeg";